import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {AuthenticatorService} from './authenticator.service';
import {AppConfigService} from './app-config.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        private authenticatorService: AuthenticatorService,
        private appConfigService: AppConfigService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.authenticatorService.getLocalStorageToken();
        // Only attach our auth token to backend API calls. Adding a custom header to a
        // presigned S3 URL turns the request into a CORS "non-simple" request, triggering a
        // preflight the blobstore bucket has no CORS rules for — which fails the request.
        // Presigned URLs are self-authenticating, so they must not carry X-Auth-Token anyway.
        const apiGatewayUrl = this.appConfigService.settings?.apiGatewayUrl;
        if (token && apiGatewayUrl && request.url.startsWith(apiGatewayUrl)) {
            request = request.clone({
                setHeaders: {
                    'X-Auth-Token': `${token}`
                }
            });
        }
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    this.authenticatorService.redirectToPF();
                }
                throw error; // Re-throw the error to propagate it further
            })
        );
    }
}
